import script from "./ExamHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamHeader.vue?vue&type=script&setup=true&lang=js"

import "./ExamHeader.vue?vue&type=style&index=0&id=7b587e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b587e04"]])

export default __exports__